import { StyleSheet, Text, View } from 'react-native'
import { ThemedView } from '@app/theme'
import { lightPalette } from '@app/theme/colors'

const LinearProgressBar = ({ progress = 0 }: { progress: number }) => {

  return (
    <ThemedView>
        <ThemedView style={{ width: '100%', borderRadius: 3 , overflow: 'hidden', height: 6, backgroundColor: lightPalette.green[300] }}>
            <ThemedView style={{ width: `${progress}%`, borderRadius: 3, overflow: 'hidden', height: 6, backgroundColor: lightPalette.green[900] }} />
        </ThemedView>
    </ThemedView>
  )
}

export default LinearProgressBar

const styles = StyleSheet.create({})